export const usersData = [
	{
		id: '1',
		name: 'Readability Acadmy',
		email: 'eileen_h@hotmail.com',
		img: '/img/avatars/thumb-1.jpg'
	},
	{
		id: '2',
		name: 'Terrance Moreno',
		email: 'terrance_moreno@infotech.io',
		img: '/img/avatars/thumb-2.jpg'
	},
	{
		id: '3',
		name: 'Ron Vargas',
		email: 'ronnie_vergas@infotech.io',
		img: '/img/avatars/thumb-3.jpg'
	},
	{
		id: '4',
		name: 'Luke Cook',
		email: 'cookie_lukie@hotmail.com',
		img: '/img/avatars/thumb-4.jpg'
	},
	{
		id: '5',
		name: 'Joyce Freeman',
		email: 'joyce991@infotech.io',
		img: '/img/avatars/thumb-5.jpg'
	},
	{
		id: '6',
		name: 'Samantha Phillips',
		email: 'samanthaphil@infotech.io',
		img: '/img/avatars/thumb-6.jpg'
	},
	{
		id: '7',
		name: 'Tara Fletcher',
		email: 'taratarara@imaze.edu.du',
		img: '/img/avatars/thumb-7.jpg'
	},
	{
		id: '8',
		name: 'Frederick Adams',
		email: 'iamfred@imaze.infotech.io',
		img: '/img/avatars/thumb-8.jpg'
	},
	{
		id: '9',
		name: 'Carolyn Hanson',
		email: 'carolyn_h@gmail.com',
		img: '/img/avatars/thumb-9.jpg'
	},
	{
		id: '10',
		name: 'Brittany Hale',
		email: 'brittany1134@gmail.com',
		img: '/img/avatars/thumb-10.jpg'
	},
	{
		id: '11',
		name: 'Lloyd Obrien',
		email: 'handsome-obrien@hotmail.com',
		img: '/img/avatars/thumb-11.jpg'
	},
	{
		id: '12',
		name: 'Gabriella May',
		email: 'maymaymay12@infotech.io',
		img: '/img/avatars/thumb-12.jpg'
	},
	{
		id: '13',
		name: 'Loranzo',
		email: 'loranzo@infotech.io',
		img: '/img/avatars/thumb-13.jpg'
	},
	{
		id: '14',
		name: 'Sue',
		email: 'sue@infotech.io',
		img: '/img/avatars/thumb-14.jpg'
	},
	{
		id: '15',
		name: 'Rya',
		email: 'rya@infotech.io',
		img: '/img/avatars/thumb-15.jpg'
	},
	
]

export const userDetailData = [
	{
		id: '1',
		name: 'Namrata ',
		teacherphone: '+91 98903 54960',
		email: 'namratapotdaraaaaaaa@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-10.jpg',
        imgAlt: '/img/avatars/jj.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '2',
		name: 'sahas',
		email: 'sahas@yopmail.com',
		teachername: 'Whitecotton',
		institution: 'Sun university',
		book: 'Pedro Goes Wild!',
		bookImage:'Capstone',
		bookAuthor:'Capstone',
		instittuteph :'9960221626',
		teacheremail: 'whitecotton123@yopmail.com',
		teacherphone: '9552559052',
		books: '0',
		age: '4 yrs',
		grade: '3',
		class: '2',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-3.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Software Engineer',
			birthday: '03/02/1984',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Terrance Moreno',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Terrance Moreno',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '3',
		name: 'sanika',
		teacherphone: '+91 98903 54960',
		email: 'sanika@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-7.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '4',
		name: 'haiya ',
		teacherphone: '+91 98903 54960',
		email: 'haiya@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-4.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '5',
		name: 'sarthak',
		teacherphone: '+91 98903 54960',
		email: 'sarthak@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-8.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
			id: '#36223',
			name: 'mamta',
			email: 'mamtafromjj@yopmail.com',
			teachername: 'Maria Wonderland',
			bookName :'Yasmin the Chef',
			bookAuthor:'Capstone',
			bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
			teacheremail: 'maria@demo.com',
			teacherphone :'123456789',
			institution :'Test-Inst-CA',
		    district: 'PABC School District	une',
			state: 'California',
			country: 'United States',  
			books: '0',
			age: '8 yrs',
			student:'0',
			grade: '0',
			class: '0',
			reading_shedule: '20 Min(s)/Day @ 10:30 PM',
			signup_date: '23 Aust,2022',
			img: '/img/avatars/thumb-1.jpg',
			lastOnline: 1623430400,
			status: 'active',
				// id: '#36223',
				// item: 'JJ School of Arts sss',
				// status: 'pending',
				// amount: 39.9,
				// date: 1639132800
			},
			{
				id: '#34283',
				name: 'Namrata',
				bookName :'Pedro Goes Wild!',
				bookAuthor:'Capstone',
				bookImage :'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'KR',
				district: 'PABC School District	une',
				state: 'California',
				country: 'United States',  
				institution :'Test-Inst-CA',
				teacheremail: 'kr-06172022@yopmail.com',
				teacherphone :'123456789',
				books: '0',
				age: '8 yrs',
				student:'0',
				grade: '0',
				class: '0',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#32234',
				name: 'sara',
				bookName :'The Haunted Backpack',
				bookAuthor:'Capstone',
				bookImage :'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				email: 'sara123@yopmail.com',
				teachername: 'Sayali B',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'sayali999@yopmail.com',
				teacherphone :'123456789',
				books: '1',
				age: '8 yrs',
				student:'2',
				grade: '1',
				class: '1',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#31354',
				name: 'Namrata',
				bookName :'Yasmin the Chef',
				bookAuthor:'Capstone',
				bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'Madhavi',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'madhavi.teacher@yopmail.com',
				teacherphone :'9960435534',
				books: '3',
				age: '8 yrs',
				student:'19',
				grade: '1',
				class: '2',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '25 may,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '6',
		name: 'manjushri',
		teacherphone: '+91 98903 54960',
		email: 'manjushri@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-1.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
			id: '#36223',
			name: 'mamta',
			email: 'mamtafromjj@yopmail.com',
			teachername: 'Maria Wonderland',
			bookName :'Yasmin the Chef',
			bookAuthor:'Capstone',
			bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
			teacheremail: 'maria@demo.com',
			teacherphone :'123456789',
			institution :'Test-Inst-CA',
		    district: 'PABC School District	une',
			state: 'California',
			country: 'United States',  
			books: '0',
			age: '8 yrs',
			student:'0',
			grade: '0',
			class: '0',
			reading_shedule: '20 Min(s)/Day @ 10:30 PM',
			signup_date: '23 Aust,2022',
			img: '/img/avatars/thumb-1.jpg',
			lastOnline: 1623430400,
			status: 'active',
				// id: '#36223',
				// item: 'JJ School of Arts sss',
				// status: 'pending',
				// amount: 39.9,
				// date: 1639132800
			},
			{
				id: '#34283',
				name: 'Namrata',
				bookName :'Pedro Goes Wild!',
				bookAuthor:'Capstone',
				bookImage :'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'KR',
				district: 'PABC School District	une',
				state: 'California',
				country: 'United States',  
				institution :'Test-Inst-CA',
				teacheremail: 'kr-06172022@yopmail.com',
				teacherphone :'123456789',
				books: '0',
				age: '8 yrs',
				student:'0',
				grade: '0',
				class: '0',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#32234',
				name: 'sara',
				bookName :'The Haunted Backpack',
				bookAuthor:'Capstone',
				bookImage :'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				email: 'sara123@yopmail.com',
				teachername: 'Sayali B',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'sayali999@yopmail.com',
				teacherphone :'123456789',
				books: '1',
				age: '8 yrs',
				student:'2',
				grade: '1',
				class: '1',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#31354',
				name: 'Namrata',
				bookName :'Yasmin the Chef',
				bookAuthor:'Capstone',
				bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'Madhavi',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'madhavi.teacher@yopmail.com',
				teacherphone :'9960435534',
				books: '3',
				age: '8 yrs',
				student:'19',
				grade: '1',
				class: '2',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '25 may,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '7',
		name: 'SweetyJo',
		teacherphone: '+91 98903 54960',
		email: 'SweetyJo@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-5.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
			id: '#36223',
			name: 'mamta',
			email: 'mamtafromjj@yopmail.com',
			teachername: 'Maria Wonderland',
			bookName :'Yasmin the Chef',
			bookAuthor:'Capstone',
			bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
			teacheremail: 'maria@demo.com',
			teacherphone :'123456789',
			institution :'Test-Inst-CA',
		    district: 'PABC School District	une',
			state: 'California',
			country: 'United States',  
			books: '0',
			age: '8 yrs',
			student:'0',
			grade: '0',
			class: '0',
			reading_shedule: '20 Min(s)/Day @ 10:30 PM',
			signup_date: '23 Aust,2022',
			img: '/img/avatars/thumb-1.jpg',
			lastOnline: 1623430400,
			status: 'active',
				// id: '#36223',
				// item: 'JJ School of Arts sss',
				// status: 'pending',
				// amount: 39.9,
				// date: 1639132800
			},
			{
				id: '#34283',
				name: 'Namrata',
				bookName :'Pedro Goes Wild!',
				bookAuthor:'Capstone',
				bookImage :'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'KR',
				district: 'PABC School District	une',
				state: 'California',
				country: 'United States',  
				institution :'Test-Inst-CA',
				teacheremail: 'kr-06172022@yopmail.com',
				teacherphone :'123456789',
				books: '0',
				age: '8 yrs',
				student:'0',
				grade: '0',
				class: '0',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#32234',
				name: 'sara',
				bookName :'The Haunted Backpack',
				bookAuthor:'Capstone',
				bookImage :'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				email: 'sara123@yopmail.com',
				teachername: 'Sayali B',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'sayali999@yopmail.com',
				teacherphone :'123456789',
				books: '1',
				age: '8 yrs',
				student:'2',
				grade: '1',
				class: '1',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#31354',
				name: 'Namrata',
				bookName :'Yasmin the Chef',
				bookAuthor:'Capstone',
				bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'Madhavi',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'madhavi.teacher@yopmail.com',
				teacherphone :'9960435534',
				books: '3',
				age: '8 yrs',
				student:'19',
				grade: '1',
				class: '2',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '25 may,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '8',
		name: 'MeriJo',
		teacherphone: '+91 98903 54960',
		email: 'MeriJo@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-9.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '9',
		name: 'aratika',
		teacherphone: '+91 98903 54960',
		email: 'aratika@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-1.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '10',
		name: 'advika',
		teacherphone: '+91 98903 54960',
		email: 'advika@yopmail.com',
		teachername: 'mamta',
		instituteemail:'jj.s11@yopmail.com',
		institution: 'JJ School of Arts',
		instittuteph :'9960221626',
		teacheremail: 'mamtafromjj@yopmail.com',
		books: '0',
		age: '8 yrs',
		grade: 'pre-k',
		class: 'carolyn_h@hotmail.com',
		reading_shedule: '20 Min(s)/Day @ 10:30 PM',
		signup_date: 'today',
		img: '/img/avatars/thumb-15.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
			id: '#36223',
			name: 'mamta',
			email: 'mamtafromjj@yopmail.com',
			teachername: 'Maria Wonderland',
			bookName :'Yasmin the Chef',
			bookAuthor:'Capstone',
			bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
			teacheremail: 'maria@demo.com',
			teacherphone :'123456789',
			institution :'Test-Inst-CA',
		    district: 'PABC School District	une',
			state: 'California',
			country: 'United States',  
			books: '0',
			age: '8 yrs',
			student:'0',
			grade: '0',
			class: '0',
			reading_shedule: '20 Min(s)/Day @ 10:30 PM',
			signup_date: '23 Aust,2022',
			img: '/img/avatars/thumb-1.jpg',
			lastOnline: 1623430400,
			status: 'active',
				// id: '#36223',
				// item: 'JJ School of Arts sss',
				// status: 'pending',
				// amount: 39.9,
				// date: 1639132800
			},
			{
				id: '#34283',
				name: 'Namrata',
				bookName :'Pedro Goes Wild!',
				bookAuthor:'Capstone',
				bookImage :'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'KR',
				district: 'PABC School District	une',
				state: 'California',
				country: 'United States',  
				institution :'Test-Inst-CA',
				teacheremail: 'kr-06172022@yopmail.com',
				teacherphone :'123456789',
				books: '0',
				age: '8 yrs',
				student:'0',
				grade: '0',
				class: '0',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#32234',
				name: 'sara',
				bookName :'The Haunted Backpack',
				bookAuthor:'Capstone',
				bookImage :'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				email: 'sara123@yopmail.com',
				teachername: 'Sayali B',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'sayali999@yopmail.com',
				teacherphone :'123456789',
				books: '1',
				age: '8 yrs',
				student:'2',
				grade: '1',
				class: '1',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '17 jun,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
			{
				id: '#31354',
				name: 'Namrata',
				bookName :'Yasmin the Chef',
				bookAuthor:'Capstone',
				bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
				email: 'namratapotdaraaaaaaa@yopmail.com',
				teachername: 'Madhavi',
				district: 'Pune',
				state: 'Maharashtra',
				country: 'India',  
				institution :'Sun university',
				teacheremail: 'madhavi.teacher@yopmail.com',
				teacherphone :'9960435534',
				books: '3',
				age: '8 yrs',
				student:'19',
				grade: '1',
				class: '2',
				reading_shedule: '20 Min(s)/Day @ 10:30 PM',
				signup_date: '25 may,2022',
				img: '/img/avatars/thumb-1.jpg',
				lastOnline: 1623430400,
				status: 'active',
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '11',
		name: 'advika',
		email: 'advika123@yopmail.com',
		teachername: 'Madhavi',
		teacheremail: 'madhavi.teacher@yopmail.com',
		books: '0',
		age: '4 yrs',
		grade: '3',
		class: '2',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-14.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Lloyd Obrien',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Lloyd Obrien',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '12',
		name: 'amla, rowanil',
		email: 'amvarela01111@yopmail.com',
		teachername: 'anjali',
		teacheremail: 'anjali123@yopmail.com',
		books: '0',
		age: '5 yrs',
		grade: 'k',
		class: 'k',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-1.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'Sea Floor',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Alex The Fish',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Rudransh, Illustrated by: Jada Kurian',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				title: 'Ben and Heart At The Park',
				img:'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				author : 'Written by: Rayana, Illustrated by: Jada Kurian',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'The Magic Train',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Written by: Christen Illustrated by: Jada Kurian',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Gabriella May',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Gabriella May',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '13',
		name: 'Loranzo, Rowan',
		email: 'amvarela01111@yopmail.com',
		teachername: 'anjali',
		teacheremail: 'anjali123@yopmail.com',
		books: '0',
		age: '5 yrs',
		grade: 'k',
		class: 'k',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-7.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'Forest Floor',
				comprehension:'2/2',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '5 feb',
				start : '07:25 AM',
				finish : '07:58 AM',
				duration: '2 min(s)',
				accuracy : '62.09%',
				wpm: '68',
				vocabulary: '0',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Sea Stars',
				comprehension:'3/2',
				img:'/img/books/6d737842-743e-4f20-8a05-0772fca8c25e.jpeg',
				author : 'Open Equal Free Inc.',
				summary_date : '30JUN,2022',
				start : '2:30 AM',
				finish : '6:72 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				title: 'Wonky Wombat',
				comprehension:'2/2',
				img:'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
				author : 'Written by: Shriya Jain, Illustrated by: Jada Kurian',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'My inside weather',
				img:'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				author : 'Jen Thorpe Lara Berge Emma Beckett',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				comprehension:'3/2',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Lee Wheeler',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Lee Wheeler',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '14',
		name: 'Sue, Aria',
		email: 'alyraegomez111@yopmail.com',
		teachername: 'anjali',
		teacheremail: 'anjali123@yopmail.com',
		books: '0',
		age: '10 yrs',
		grade: '5',
		class: '5',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-5.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'Who Ate All That Up?',
				img:'/img/books/6a560996-4858-4c6f-ab3f-43e23e881b6c.jpeg',
				author : 'Author: Sejal Mehta Illustrator: Rohan Chakravarty',
				summary_date : 'Before 7h 25M',
				start : '11:40 AM',
				finish : '11:55 AM',
				duration: '3 min(s)',
				accuracy : '73.09%',
				comprehension:'2/2',
				wpm: '0',
				vocabulary: '5',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'What Happens After The Sun Sets?',
				img:'/img/books/bbe62243-c063-4843-ac42-3884cc8a31d3.jpeg',
				author : 'Written by Chloe Laughlin, Illustrated by Jada Kurian',
				summary_date : 'Yesterday',
				start : '5:34 AM',
				finish : '5:34 AM',
				duration: '1 min(s)',
				comprehension:'3/2',
				accuracy : '100.00%',
				wpm: '0',
				vocabulary: '1',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				title: 'hello',
				img:'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
				author : 'Jennie Marima Imile Wepener Rox Jaden Palmer',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				comprehension:'1/2',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Kate Goes To School',
				img:'/img/books/6d737842-743e-4f20-8a05-0772fca8c25e.jpeg',
				author : 'Written by: Rayana, Illustrated by: Colson Timblin',
				summary_date : '5 feb',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				comprehension:'3/2',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Gail Barnes',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Gail Barnes',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '15',
		name: 'Rya',
		email: 'rya@yopmail.com',
		teachername: 'Anjali',
		teacheremail: 'anjali123@yopmail.com',
		books: '0',
		age: '4 yrs',
		grade: 'k',
		class: 'k',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-10.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '16',
		name: 'Rose',
		email: 'rose@yopmail.com',
		teachername: 'Anjali',
		teacheremail: 'anjali123@yopmail.com',
		books: '0',
		age: '4 yrs',
		grade: 'k',
		class: 'k',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-10.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '17',
		name: 'Kate',
		email: 'rya@yopmail.com',
		teachername: 'Anjali',
		teacheremail: 'anjali123@yopmail.com',
		books: '0',
		age: '4 yrs',
		grade: 'k',
		class: 'k',
		reading_shedule: '10 Min(s)/Day @ 10:30 PM',
		signup_date: 'before 2h 55min',
		img: '/img/avatars/thumb-9.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				title: 'I Can Climb!',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'Author: Mini Shrinivasan Illustrator: Deval Maniar',
				summary_date : '30JUN,2022',
				comprehension:'2/2',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				title: 'Car Race',
				comprehension:'3/3',
				img:'/img/books/e4625426-3493-429e-98d7-c51563e9922d.jpeg',
				author : 'Written by: Chloe Laughlin, Illustrated by: Colson Timblin',
				summary_date : '7 jAN,2022',
				start : '05:23 AM',
				finish : '05:26 AM',
				duration: '3 min(s)',
				accuracy : '79.33%',
				wpm: '0',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#32234',
				comprehension:'1/1',
				title: 'Alphi Blows Bubbles',
				img:'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
				author : 'by Tony J Moon',
				summary_date : '5 JUN,2022',
				start : '02:20 AM',
				finish : '02:22 AM',
				duration: '2 min(s)',
				accuracy : '54.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#31354',
				title: 'Finbo',
				comprehension:'1/2',
				img:'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
				author : 'Written & Illustrated by Janaki Sooriyarachchi',
				summary_date : '30JUN,2022',
				start : '07:20 AM',
				finish : '07:22 AM',
				duration: '2 min(s)',
				accuracy : '96.09%',
				wpm: '54',
				vocabulary: '3',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	}
]


export const institutionsDetailData = [
	{
		id: '1',
		name: 'jjsl',
		institute: 'Sun university',
		email: 'jj.s11@yopmail.com',
		img: '/img/avatars/thumb-1.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		country: 'India',
		state: 'Maharashtra',
		district: 'Pune',
		phone: 9960221626,
		teachers: '7',
		students: '14',
		classess: '4',
		status: 'active',
	
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '2',
		name: 'Sun university',
		institute: 'Sun university',
		email: 'sun@yopmail.com',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		lastOnline: 1632393600,
		country: 'India',
		state: 'Maharashtra',
		district: 'Pune',
		teachers: '3',
		phone: 9960221626,
		students: '20',
		classess: '3',
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Software Engineer',
			birthday: '03/02/1984',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Terrance Moreno',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Terrance Moreno',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '3',
		name: 'Readability Academyy',
		institute: 'Readability Academy',
		email: 'ReadabilityAcademy@yopmail.com',
		img: '',
		role: 'User',
		phone: 9529859793,
		country: 'India',
		state: 'Maharashtra',
		district: 'Pune',
		teachers: '3',
		students: '20',
		classess: '3',
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'UI/UX Designer',
			birthday: '07/11/1987',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ron Vargas',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ron Vargas',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '4',	
		institute: 'Call Training',
		name: 'Sheetal',
		email: 'peacesheetal222_2@yopmail.com',
		phone: 9922918546,
		country: 'India',
		state: 'Maharashtra',
		district: 'Pune',
		teachers: '2',
		students: '1',
		classess: '1',
		img: '/img/institute/kids-160168__340_a3d497db-3724-4ca6-af9b-e161061dc6d2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'HR Executive',
			birthday: '07/11/1987',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Luke Cook',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Luke Cook',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '5',	
		institute: 'Downlands Community Primary School',
		name: 'downlands',
		email: 'downlands@yopmail.com',
		phone: 9922918546,
		country: 'United Kingdom',
		state: 'Dorset',
		district: 'dorset',
		teachers: '8',
		students: '5',
		classess: '2',
		img: '/img/avatars/thumb-6.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Frontend Developer',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Joyce Freeman',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Joyce Freeman',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '6',	
		institute: 'little leaf',
		name: 'little leafy',
		email: 'little.leaf3@yopmail.com',
		phone: 9922765432,
		country: 'United Kingdom',
		state: 'Dorset',
		district: 'dorset',
		teachers: '1',
		students: '13',
		classess: '4',
		img: '/img/avatars/thumb-3.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Compliance Manager',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Samantha Phillips',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Samantha Phillips',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '7',	
		institute: 'Gonzalves ele',
		name: 'KR Gonzalves',
		email: 'little.leaf3@yopmail.com',
		phone: 9922765432,
		country: 'United Kingdom',
		state: 'California',
		district: 'ABC School District',
		teachers: '2',
		students: '25',
		classess: '2',
		img: '',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Compliance Manager',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Tara Fletcher',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Tara Fletcher',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '8',	
		institute: 'UK public school',
		name: 'ukpublicschool',
		email: 'ukpublicschool@yopmail.com',
		phone: 9989898988,
		country: 'United Kingdom',
		state: 'Dorset',
		district: 'Dorset',
		teachers: '4',
		students: '18',
		classess: '6',
		img: '',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Compliance Manager',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Frederick Adams',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Frederick Adams',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '9',	
		institute: 'Stowers Elementory',
		name: 'KR',
		email: 'kr-stowers-ele@yopmail.com',
		phone: 3109773821,
		country: 'United Kingdom',
		state: 'California',
		district: 'ABC School District',
		teachers: '3',
		students: '4',
		classess: '3',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'Texas, US',
			title: 'Compliance Manager',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Carolyn Hanson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Carolyn Hanson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '10',	
		institute: 'dorset public school',
		name: 'dorset',
		email: 'doremon123@yopmail.com',
		phone: 3109773821,
		country: 'United Kingdom',
		state: 'California',
		district: 'ABC School District',
		teachers: '3',
		students: '4',
		classess: '3',
		img: '',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'Texas, US',
			title: 'Compliance Manager',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Brittany Hale',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Brittany Hale',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '11',	
		institute: 'Poole High School',
		name: 'PooleHighSchool',
		email: 'PooleHighSchool@yopmail.com',
		phone: 3109773821,
		country: 'United Kingdom',
		state: 'Dorset',
		district: 'Poole',
		teachers: '0',
		students: '0',
		classess: '0',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Lloyd Obrien',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Lloyd Obrien',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '12',	
		institute: 'Montacute School',
		name: 'montacute',
		email: 'montacute@yopmail.com',
		phone: 3109773821,
		country: 'United Kingdom',
		state: 'Dorset',
		district: 'Poole',
		teachers: '2',
		students: '8',
		classess: '3',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Gabriella May',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Gabriella May',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '13',	
		institute: 'The Royal Academy School',
		name: 'The Royal Academy School',
		email: 'theroyalacademy@yopmail.com',
		phone: 3109773821,
		country: 'United Arab Emirates	',
		state: 'Ajman',
		district: 'Masfout',
		teachers: '3',
		students: '5',
		classess: '5',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Lee Wheeler',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Lee Wheeler',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '14',	
		institute: 'Kanya School',
		name: 'kanya',
		email: 'kanya@yopmail.com',
		phone: 3109773821,
		country: 'India',
		state: 'Maharashtra',
		district: 'Pune',
		teachers: '24',
		students: '11',
		classess: '4',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Gail Barnes',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Gail Barnes',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '15',	
		institute: 'KK public school',
		name: 'KK public school',
		email: 'kkpublicschool@yopmail.com',
		phone: 8669159202,
		country: 'India',
		state: 'Maharashtra',
		district: 'Pune',
		teachers: '7',
		students: '14',
		classess: '4',
		img: '/img/avatars/thumb-2.jpg',
		role: 'User',
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	}
]


export const teachersDetailData = [
	{
		id: '1',
		name: 'mamta',
		email: 'mamtafromjj@yopmail.com',
		institution: 'JJ School of Arts',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '1',
		books: '0',
		classess: '1',
		created_date: '22 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Product Manager',
			birthday: '10/10/1992',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHoldername: 'Carolyn Perkins',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '2',
		name: 'Cristina Magistrado',
		email: 'Cristina.Magistrado@yopmail.com',
		phone : '9922918546',
		institution: 'Readability Academy',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '2',
		books: '25',
		classess: '1',
		created_date: '23 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Software Engineer',
			birthday: '03/02/1984',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				name: 'mamta',
		email: 'mamtafromjj@yopmail.com',
		institution: 'JJ School of Arts',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '1',
		books: '0',
		classess: '1',
		created_date: '23 jan,2022',
		img: '/img/avatars/thumb-1.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Terrance Moreno',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Terrance Moreno',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '3',
		name: 'Vimal Patel',
		email: 'vimalpatel19122022_1@yopmail.com',
		phone : '9922918546',
		institution: 'Shanu Patel School',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '25 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'UI/UX Designer',
			birthday: '07/11/1987',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ron Vargas',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ron Vargas',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '4',
		name: 'Vimal Patel',
		email: 'vimalpatel19122022_1@yopmail.com',
		phone : '1234786790',
		institution: 'Vimal Patel School',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '26 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'HR Executive',
			birthday: '07/11/1987',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Luke Cook',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Luke Cook',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '5',
		name: 'Malvika Tambe',
		email: 'malvikatambe123@yopmail.com',
		phone : '123456790',
		institution: 'Vimal Patel School',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '27 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'New York, US',
			title: 'Frontend Developer',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack kk',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Joyce Freeman',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Joyce Freeman',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '6',
		name: 'latifa',
		email: 'latifa@yopmail.com',
		phone : '123456789',
		institution: 'UK public school',
		district: 'dorset',
		state: 'dorset',
		country: 'United Kingdom',
		student: '1',
		books: '0',
		classess: '1',
		created_date: '28 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Compliance Manager',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack jjjjjjj',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Samantha Phillips',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Samantha Phillips',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '7',
		name: 'Malvika T',
		email: 'malvika123@yopmail.com',
		phone : '123456790',
		institution: 'Downlands Community Primary School',
		district: 'dorset',
		state: 'dorset',
		country: 'United Kingdom',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '29 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Compliance Manager',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack fghgfh',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Tara Fletcher',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Tara Fletcher',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '8',
		name: 'Anushka Sharma ',
		email: 'anushka.sharma@demo.com',
		phone : '123456790',
		institution: 'UK public school	',
		district: 'dorset',
		state: 'dorset',
		country: 'United Kingdom',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '30 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Compliance Manager',
			birthday: '17/11/1993',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack kkk',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Frederick Adams',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Frederick Adams',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '9',
		name: 'Maria Wonderland',
		email: 'maria@demo.com',
		phone : '123456790',
		institution: 'Test-Inst-CA',
		district: 'ABC School District	',
		state: 'California',
		country: 'United Kingdom',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '2 feb',
		img: '/img/avatars/thumb-1.jpg',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'Texas, US',
			title: 'Compliance Manager',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack gjdfj',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Carolyn Hanson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Carolyn Hanson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '10',
		name: 'Sayali B',
		email: 'sayali999@yopmail.com',
		phone : '123456790',
		institution: 'Sun university	',
		district: 'Maharashtra',
		state: 'Maharashtra',
		country: 'India',
		student: '1',
		books: '2',
		classess: '1',
		created_date: '3 feb',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'Texas, US',
			title: 'Compliance Manager',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack ghj',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Brittany Hale',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Brittany Hale',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '11',
		name: 'KR',
		email: 'kr-06172022@yopmail.com',
		phone : '123456790',
		institution: 'Test-Inst-CA',
		district: 'ABC School District	',
		state: 'California',
		country: 'United States	',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '4 feb',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack fh',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Lloyd Obrien',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Lloyd Obrien',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '12',
		name: 'Madhavi',
		email: 'madhavi.teacher@yopmail.com',
		phone : '9960435534',
		institution: 'Sun university',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '3',
		books: '1',
		classess: '2',
		created_date: '5 feb',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pac kkk',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Gabriella May',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Gabriella May',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '13',
		name: 'Suleman',
		email: 'suleman23051@demo.com',
		phone : '9960435534',
		institution: 'Sun university',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '3',
		books: '1',
		classess: '2',
		created_date: '6 feb',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack dfh',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Lee Wheeler',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Lee Wheeler',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '14',
		name: 'Shriya Jain',
		email: 'Shriya.Jain@yopmail.com',
		phone : '9960435534',
		institution: 'Readability Academy	',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '32',
		books: '74',
		classess: '2',
		created_date: '7 feb',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack sfasdg',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Gail Barnes',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Gail Barnes',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	},
	{
		id: '15',
		name: 'Chloe Laughllin',
		email: 'Shriya.Jain@yopmail.com',
		phone : '9960435534',
		institution: 'Readability Academy	',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '2',
		books: '81',
		classess: '1',
		created_date: '8 feb',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		personalInfo: {
			location: 'London, UK',
			title: 'Software Engineer',
			birthday: '03/06/1991',
			phoneNumber: '+12-123-1234',
			facebook: 'facebook.com/sample',
			twitter: 'twitter.com/sample',
			pinterest: 'pinterest.com/sample',
			linkedIn: 'linkedin/sample'
		},
		orderHistory: [
			{
				id: '#36223',
				item: 'Mock premium pack sss',
				status: 'pending',
				amount: 39.9,
				date: 1639132800
			},
			{
				id: '#34283',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1636790880
			},
			{
				id: '#32234',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1634090880
			},
			{
				id: '#31354',
				item: 'Business board pro subscription',
				status: 'paid',
				amount: 59.9,
				date: 1631532800
			},
		],
		paymentMethod: [
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'VISA',
				expMonth: '12',
				expYear: '25',
				last4Number: '0392',
				primary: true,
			},
			{
				cardHolderName: 'Ella Robinson',
				cardType: 'MASTER',
				expMonth: '06',
				expYear: '25',
				last4Number: '8461',
				primary: false,
			}
		],
		subscription: [
			{
				plan: 'Business board pro',
				status: 'active',
				billing: 'monthly',
				nextPaymentDate: 1639132800,
				amount: 59.9
			}
		]
	}
]
export const booksDetailData = [
	{
		id: '1',
		name: 'mamta',
		level:'1-1',
		comprehension:'2/2',
		question:'1',
		chapters:'15',
		voabulary:'0',
		words:'428',
		bookImage :'/img/books/6a560996-4858-4c6f-ab3f-43e23e881b6c.jpeg',
		email: 'mamtafromjj@yopmail.com',
		bookName: 'Yasmin the Chef',
		grade: '1',
		bookAuthor:'Capstone',
		district: 'Pune',
		arscore:'1',
		state: 'Maharashtra',
		country: 'India',
		student: '1',
		books: '0',
		classess: '1',
		created_date: '22 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
		
	
	},
	{
		id: '2',
		words:'4',
		voabulary:'1',
		comprehension:'3/2',
		level:'-',
		bookImage :'/img/books/aea93778-8e70-4560-b348-515360fe8021.jpeg',
		name: 'Cristina Magistrado',
		grade: '1',
		chapters:'16',
		question:'1',
		email: 'Cristina.Magistrado@yopmail.com',
		phone : '9922918546',
		bookName: 'Pedro Goes Wild!',
		bookAuthor:'Capstone',
		district: 'Pune',
		arscore:'1',
		state: 'Maharashtra',
		country: 'India',
		student: '2',
		books: '25',
		classess: '1',
		created_date: '23 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
			
	},
	{
		id: '3',
		name: 'Vimal Patel',
		chapters:'15',
		words:'4325',
		voabulary:'0',
		question:'2',
		comprehension:'2/2',
		level:'-',
		arscore:'1',
		bookAuthor:'Capstone',
		grade: 'K',
		email: 'vimalpatel19122022_1@yopmail.com',
		phone : '9922918546',
		bookImage :'/img/books/b2df1343-d6fb-405d-b212-283888ed62e6.jpeg',
		bookName: 'The Haunted Backpack',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '25 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',

	
	},
	{
		id: '4',
		bookImage :'/img/books/cc5b8f8e-8fb5-4473-8d70-b303299a8308.jpeg',
		question:'1',
		arscore:'1',
		chapters:'12',
		comprehension:'3/2',
		level:'-',
		voabulary:'0',
		email: 'vimalpatel19122022_1@yopmail.com',
		phone : '1234786790',
		grade: '5',
		words:'4325',
		bookAuthor:'Capstone',
		bookName: 'Yasmin the Chef',
		district: 'Pune',
		state: 'Maharashtra',
		country: 'India',
		student: '0',
		books: '0',
		classess: '0',
		created_date: '26 jan',
		img: '',
		role: 'Admin',
		lastOnline: 1623430400,
		status: 'active',
	
	},	
	
]

export const reportdata = [
	{
		id: '1',
		name: 'Teacher - Marcela DeVivo',
		reader:'',
		books:'118',
		total: '2',
	    onplatform:'0',
		notOnPlatform:'0',
		active:'2',
		notActive:'0',
		minutesRead:'1918',
		averageAccuracy:'80,3%',
		comprehension:'75.9%',
		speed:'85',
		movedLevelUp:'0',
		movedLevelDown:'0'

		
	},
	{
		id: '2',
		name: 'Teacher - Chloe Laughllin',
		reader:'',
		books:'109',
		total: '2',
	    onplatform:'2',
		notOnPlatform:'0',
		active:'2',
		notActive:'0',
		minutesRead:'1025',
		averageAccuracy:'80.5%',
		comprehension:'70.7%',
		speed:'53',
		movedLevelUp:'0',
		movedLevelDown:'0'
		
	},
	{
		id: '3',
		name: 'Teacher - Shriya Jain',
		reader:'',
		books:'124',
		total: '4',
	    onplatform:'4',
		notOnPlatform:'0',
		active:'4',
		notActive:'2',
		minutesRead:'889',
		averageAccuracy:'77.9%',
		comprehension:'78.0%',
		speed:'76',
		movedLevelUp:'0',
		movedLevelDown:'0'
		
	},
	{
		id: '4',
		name: 'Teacher - Cristina Magistrado',
		reader:'',
		books:'119',
		total: '2',
	    onplatform:'0',
		notOnPlatform:'2',
		active:'2',
		notActive:'0',
		minutesRead:'394',
		averageAccuracy:'59.8%',
		comprehension:'76.7%',
		speed:'64',
		movedLevelUp:'0',
		movedLevelDown:'0'
	
	},
	{
		id: '5',
		name: 'Teacher - harshad hansal',
		reader:'',
		books:'0',
		total: '5',
	    onplatform:'0',
		notOnPlatform:'14',
		active:'0',
		notActive:'5',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0'
		
	},
	{
		id: '6',
		name: 'Teacher - guddi kansal',
		reader:'',
		books:'0',
		total: '3',
	    onplatform:'0',
		notOnPlatform:'3',
		active:'0',
		notActive:'3',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0'
	
	},
	{
		id: '7',
		name: 'Teacher - Vickey Kansal',
		reader:'',
		books:'0',
		total: '1',
	    onplatform:'0',
		notOnPlatform:'1',
		active:'0',
		notActive:'1',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0'
	
	},
	{
		id: '8',
		name: 'Teacher - suraj',
		reader:'',
		books:'0',
		total: '27',
	    onplatform:'0',
		notOnPlatform:'27',
		active:'0',
		notActive:'27',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0'
	
	},
	{
		id: '9',
		name: 'Teacher - Mila Teacher',
		reader:'',
		books:'0',
		total: '7',
	    onplatform:'0',
		notOnPlatform:'7',
		active:'0',
		notActive:'7',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
		
		
		

	},
	{
		id: '10',
		name: 'Teacher - Katrina Teacher',
		reader:'',
		books:'0',
		total: '2',
	    onplatform:'0',
		notOnPlatform:'2',
		active:'0',
		notActive:'2',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
	

	},
	{
		id: '11',
		name: 'Teacher - KR',
		reader:'',
		books:'0',
		total: '25',
	    onplatform:'0',
		notOnPlatform:'25',
		active:'0',
		notActive:'25',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
	
	
		
	},
	{
		id: '12',
		name: 'Teacher - harshad hansal',
		reader:'',
		books:'0',
		total: '25',
	    onplatform:'0',
		notOnPlatform:'25',
		active:'0',
		notActive:'25',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
		
	},
	{
		id: '13',
		name: 'Teacher - jayant sir',
		reader:'',
		books:'0',
		total: '8',
	    onplatform:'0',
		notOnPlatform:'8',
		active:'0',
		notActive:'8',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
		
	},
	{
		id: '14',
		name: 'Teacher - Kamla',
		reader:'',
		books:'0',
		total: '9',
	    onplatform:'0',
		notOnPlatform:'9',
		active:'0',
		notActive:'9',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
		
	},
	{
		id: '15',
		name: 'Teacher - Vinod Sir',
		reader:'',
		books:'0',
		total: '2',
	    onplatform:'0',
		notOnPlatform:'2',
		active:'0',
		notActive:'2',
		minutesRead:'0',
		averageAccuracy:'0%',
		comprehension:'0%',
		speed:'0',
		movedLevelUp:'0',
		movedLevelDown:'0',
		

	}
]


export const classessdata = [
	{
		id: '1',
		name: 'KG',
		sections:'2',
		students:'28'
		
		
	},
	{
		id: '2',
		name: '1 st',
		sections:'1',
		students:'6'
		
	},
	{
		id: '3',
		name: '2 nd',
		sections:'1',
		students:'8'
		
	},
	{
		id: '4',
		name: '3 rd',
		sections:'7',
		students:'77'
	
	},
	{
		id: '5',
		name: '4 th',
		sections:'3',
		students:'15'
		
	},
	{
		id: '6',
		name: '5 th',
		sections:'1',
		students:'1'
	
	},
	{
		id: '7',
		name: '6 th',
		sections:'1',
		students:'1'
	
	},
	{
		id: '8',
		name: '7 th',
		sections:'2',
		students:'26'
	
	},
	{
		id: '9',
		name: '8 th',
		sections:'1',
		students:'1'
		
		
		

	},
	{
		id: '10',
	   name: '9 th',
		sections:'1',
		students:'6'
	

	},
	{
		id: '11',
		name: '11 th',
		sections:'1',
		students:'3'
	
	
		
	},
	{
		id: '12',
		name: 'Pre-K',
		sections:'5',
		students:'18'
		
	},
	{
		id: '13',
		name: 'KG',
		sections:'2',
		students:'28'
		
	},
	{
		id: '14',
		name: 'Pre-K',
		sections:'4',
		students:'20'
		
	},
	{
		id: '15',
		name: 'KG',
		sections:'2',
		students:'28'
		

	}
]